export const networkAffiliationsSectionContainer = {
  gap: '24px',
  width: '100%',
  maxWidth: '1200px',
};

export const networkAffiliationsHeaderContainer = {
  display: 'flex',
  flexWrap: 'wrap' as const,
  justifyContent: 'flex-start' as const,
  alignItems: 'center' as const,
  width: '100%',
  gap: '8px 32px',
  '@media (max-width: 743px)': {
    gap: '16px',
  },
};

export const networkAffiliationsTitleContainer = {
  display: 'flex',
  alignItems: 'center' as const,
  gap: '4px',
};

export const networkAffiliationsTitleStyle = {
  fontFamily: 'sans-serif',
  fontWeight: 700,
  fontSize: '1.25rem',
  lineHeight: '120%',
  color: '#002877',
  margin: 0,
};

export const networkAffiliationsInfoButton = {
  'abyss-button-root': {
    display: 'inline-block',
    padding: '0px',
    height: '16px',
    marginBottom: '-2.5px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
};

export const networkAffiliationsViewAllDetailsLink = {
  fontFamily: 'sans-serif',
  fontWeight: 600,
  fontSize: '$sm',
  lineHeight: '140%',
  color: '#196ECF',
  textDecoration: 'none',
  height: '20px',
  cursor: 'default',
  '&:hover': {
    textDecoration: 'none',
  },
};

export const networkAffiliationsCardsContainer = {
  display: 'flex',
  flexWrap: 'wrap' as const,
  gap: '24px',
  width: '100%',
  '@media (max-width: 743px)': {
    display: 'grid',
    gridTemplateColumns: '1fr',
    justifyContent: 'center' as const,
  },
  '@media (min-width: 744px) and (max-width: 983px)': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 344px)',
    gap: '24px',
  },
};

export const networkAffiliationsCardsContainerCollapsed = {
  display: 'flex',
  gap: '24px',
  width: '100%',
  overflow: 'hidden' as const,
  '@media (max-width: 743px)': {
    display: 'grid',
    gridTemplateColumns: '1fr',
    overflow: 'visible' as const,
    justifyContent: 'center' as const,
  },
  '@media (min-width: 744px) and (max-width: 983px)': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 344px)',
    gap: '24px',
    overflow: 'hidden' as const,
  },
};

export const networkAffiliationsLinkContainer = {
  justifyContent: 'flex-start' as const,
};

export const networkAffiliationsLinkStyle = {
  fontFamily: 'sans-serif',
  fontWeight: 600,
  fontSize: '$sm',
  lineHeight: '140%',
  color: '#196ECF',
  textDecoration: 'none',
  height: '20px',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const networkAffiliationsIconStyle = {
  color: '#196ECF',
};

export const networkAffiliationCardContainer = {
  gap: '12px',
  paddingTop: '16px',
  paddingBottom: '8px',
  paddingLeft: '0px',
  paddingRight: '0px',
  border: '1px solid var(--card-base-color-border-container, #CBCCCD)',
  borderRadius: '8px',
  width: '100%',
  minWidth: 0,
  minHeight: '100px',
  background: 'var(--card-base-color-surface-container, #FFFFFF)',
  boxSizing: 'border-box' as const,
  overflow: 'hidden' as const,
  '@media (max-width: 743px)': {
    width: '100%',
    minHeight: '100px',
    boxShadow: '0px 2px 4px -2px #00000029',
  },
  '@media (min-width: 744px) and (max-width: 983px)': {
    width: '100%',
    minHeight: '100px',
    boxShadow: '0px 2px 4px -2px #00000029',
  },
};

export const networkAffiliationCardNameContainer = {
  paddingLeft: '16px',
  paddingRight: '16px',
  overflow: 'hidden' as const,
  width: '100%',
  cursor: 'pointer',
};

export const networkAffiliationCardNameStyle = {
  fontSize: '$sm',
  lineHeight: '140%',
  color: '#196ECF',
  minHeight: '32px',
  display: 'block',
  maxWidth: '100%',
  wordWrap: 'break-word' as const,
  overflowWrap: 'break-word' as const,
  whiteSpace: 'normal' as const,
};

export const networkAffiliationCardContentContainer = {
  gap: '12px',
  paddingLeft: '16px',
  paddingRight: '16px',
};

export const networkAffiliationCardTextStyle = {
  fontSize: '$sm',
  lineHeight: '140%',
  color: '#323334',
};

export const networkAffiliationCardEnrollmentLabelStyle = {
  fontSize: '$sm',
  lineHeight: '140%',
  color: '#323334',
  flexShrink: 0,
};

export const networkAffiliationCardEnrollmentValueStyle = {
  fontSize: '$sm',
  lineHeight: '140%',
  color: '#323334',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap' as const,
  minWidth: 0,
  flex: 1,
  display: 'block',
};
